import { CardType, User } from '@generated-types';
import { cardTypeGet } from '@utils/query-utils';

import { getTypeCustomerBasePath, getTypeOrganisationBasePath, REST_BASE_URL } from '../common';

export const getCustomer = async (cardType: CardType, customerId: string, refresh: boolean = false) => {
    const refreshSearchParams = new URLSearchParams([['refresh', 'true']]);

    const searchParams = refresh ? refreshSearchParams : new URLSearchParams();

    if (customerId.substring(0, 2) === '00') {
        return cardTypeGet(cardType)<User>(
            `${REST_BASE_URL}/${getTypeOrganisationBasePath(cardType)}/${customerId}`,
            searchParams,
        );
    }

    return cardTypeGet(cardType)<User>(
        `${REST_BASE_URL}/${getTypeCustomerBasePath(cardType)}/${customerId}`,
        searchParams,
    );
};

export const getCustomers = async (cardType: CardType, customers: string[]) => {
    const query = new URLSearchParams();
    customers.forEach((customer) => query.append('customerNumber', customer));

    return cardTypeGet(cardType)<User[]>(`${REST_BASE_URL}/${getTypeCustomerBasePath(cardType)}`, query);
};

export const getMe = async () => {
    return cardTypeGet(CardType.DEBIT)<User>(`${REST_BASE_URL}/${getTypeCustomerBasePath(CardType.DEBIT)}/me`);
};
